module.exports = __webpack_public_path__ + "img/img4.a2d5767f.png";